// Conectividad en la página (sin simular): qué pines quedan unidos por cables, protoboard y
// conexiones internas de las piezas. Sirve para resaltar los puntos conectados al pasar el cursor.
import { getBuses, getDef } from './parts/index.js';
import { partProps } from './connectivity.js';

export function buildNetlist(project, layout) {
  const parent = new Map();
  const find = (k) => {
    let r = k;
    while (parent.has(r) && parent.get(r) !== r) r = parent.get(r);
    let c = k;
    while (c !== r) {
      const n = parent.get(c);
      parent.set(c, r);
      c = n;
    }
    return r;
  };
  const union = (a, b) => {
    if (!parent.has(a)) parent.set(a, a);
    if (!parent.has(b)) parent.set(b, b);
    const ra = find(a);
    const rb = find(b);
    if (ra !== rb) parent.set(ra, rb);
  };
  const key = (r) => r.part + ':' + r.pin;
  for (const w of project.wires) union(key(w.a), key(w.b));
  for (const [a, b] of layout.links) union(key(a), key(b));
  for (const part of project.parts) {
    if (part._ghost) continue;
    for (const bus of getBuses(part.type, partProps(part))) {
      for (let i = 1; i < bus.length; i++) union(part.id + ':' + bus[0], part.id + ':' + bus[i]);
    }
  }
  return {
    /** Pines unidos al pin dado (incluido él mismo), como 'pieza:pin'. */
    connected(k) {
      if (!parent.has(k)) return [k];
      const root = find(k);
      const out = [];
      for (const other of parent.keys()) if (find(other) === root) out.push(other);
      return out;
    },
  };
}

/** Agujeros de una protoboard que comparten tira con el agujero dado (aunque no haya cables). */
export function stripOf(project, k) {
  const [partId, pin] = k.split(':');
  const part = project.parts.find((p) => p.id === partId);
  if (!part || getDef(part.type).kind !== 'breadboard') return [];
  for (const bus of getBuses(part.type, partProps(part))) if (bus.includes(pin)) return bus.map((n) => partId + ':' + n);
  return [];
}
